export default __webpack_public_path__ + "static/media/WeightManagement_main.1da9618f.png";